export const CONFIG = {
  CONVERSATION_TIMEOUT_MS: 100000, // 100 seconds
};
